var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"elem",staticClass:"adriel-common-input",attrs:{"placeholder":_vm.placeholder,"type":_vm.type,"id":_vm.identifier,"autofocus":_vm.autofocus},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }